module.exports = __webpack_public_path__ + "static/media/Ressources.926c3b01.png";